import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ProductCampaignViewModel } from '@models/api-search.models';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-product-campaign',
    templateUrl: './product-campaign.component.html',
    styleUrls: ['./product-campaign.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DatePipe, TranslateSafePipe]
})
export class ProductCampaignComponent {
    @Input() campaign?: Pick<ProductCampaignViewModel, 'campaignId' | 'campaignType' | 'startDate' | 'endDate'>;
}
